import { library } from "@fortawesome/fontawesome-svg-core";

import {
  faMegaphone as farMegaphone,
  faTrashAlt,
  faBars,
  faSearch,
} from "@fortawesome/pro-regular-svg-icons";

import {
  faCheck,
  faChevronUp,
  faChevronDown,
  faChevronRight,
  faChevronLeft,
  faHome,
  faSpinner,
  faShoppingCart,
  faShoppingBasket,
  faPlus,
  faMinus,
  faTimes,
  faMapMarkerAlt,
  faPause,
  faPauseCircle,
  faPlayCircle,
  faCog,
  faChevronCircleLeft,
  faChevronCircleRight,
} from "@fortawesome/pro-solid-svg-icons";

import {
  faCommentAltDots,
  faMegaphone,
  faFileAlt,
  faClipboardList,
  faChevronRight as falChevronRight,
  faUser,
  faSignInAlt,
  faEnvelope,
  faLock,
  faUsers,
  faShoppingBasket as falShoppingBasket,
  faExternalLink,
  faExternalLinkAlt,
  faClock,
  faUserFriends,
  faTablet,
  faUserHeadset,
  faLaptop,
  faCalculator,
  faShoppingCart as falShoppingCart,
  faMobileAndroidAlt,
  faEnvelope as falEnvelope,
  faBullseyePointer,
  faLightbulbOn,
  faHeadSideBrain,
  faTv,
  faHandsHelping,
  faCalendarAlt,
  faMapMarkerAlt as falMapMarkerAlt,
  faMapMarked,
} from "@fortawesome/pro-light-svg-icons";

import { faTwitter, faLinkedin, faYoutube } from "@fortawesome/free-brands-svg-icons";

library.add( farMegaphone );

library.add( faCog );
library.add( faSearch );
library.add( faBars );
library.add( faTrashAlt );
library.add( faSpinner );
library.add( faCheck );
library.add( faChevronUp );
library.add( faChevronDown );
library.add( faChevronRight );
library.add( faChevronLeft );
library.add( faHome );
library.add( faCommentAltDots );
library.add( faMegaphone );
library.add( faFileAlt );
library.add( faClipboardList );
library.add( falChevronRight );
library.add( faTwitter );
library.add( faLinkedin );
library.add( faYoutube );
library.add( faUser );
library.add( faSignInAlt );
library.add( faEnvelope );
library.add( faLock );
library.add( faUsers );
library.add( faShoppingBasket );
library.add( falShoppingBasket );
library.add( faShoppingCart );
library.add( faPlus );
library.add( faMinus );
library.add( faExternalLink );
library.add( faExternalLinkAlt );
library.add( faTimes );
library.add( faClock );
library.add( faUserFriends );
library.add( faTablet );
library.add( faMapMarkerAlt );
library.add( faLaptop );
library.add( faCalculator );
library.add( falShoppingCart );
library.add( faMobileAndroidAlt );
library.add( falEnvelope );
library.add( faBullseyePointer );
library.add( faLightbulbOn );
library.add( faHeadSideBrain );
library.add( faUserHeadset );
library.add( faTv );
library.add( faPause );
library.add( faHandsHelping );
library.add( faPauseCircle );
library.add( faPlayCircle );
library.add( faCalendarAlt );
library.add( falMapMarkerAlt );
library.add( faMapMarked );
library.add( faChevronCircleLeft );
library.add( faChevronCircleRight );
